// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderWithSubHeader-module__container--l-LAh","header":"HeaderWithSubHeader-module__header--3nxVI","subHeader":"HeaderWithSubHeader-module__subHeader--I428I"};